import { render } from "./Culture.vue?vue&type=template&id=01b1d38a&scoped=true&ts=true"
import script from "./Culture.vue?vue&type=script&lang=ts"
export * from "./Culture.vue?vue&type=script&lang=ts"

import "./Culture.vue?vue&type=style&index=0&id=01b1d38a&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b1d38a"]])

export default __exports__